import { Waves, Users, HeartHandshake, Brain, ShieldCheck, Sprout, Home, Compass } from "lucide-react";

export const TEAM = [
  {
    name: "Dr. Marcus Bennett",
    role: "Medical Director",
    bio: "Board-certified in addiction medicine, Dr. Bennett leads our clinical team and oversees round-the-clock medical care.",
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=compress&w=800&q=80",
  },
  {
    name: "Sarah Whitfield, RN",
    role: "Head of Nursing",
    bio: "With 15 years in residential care, Sarah ensures every client feels safe, supported and cared for, day and night.",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=compress&w=800&q=80",
  },
  {
    name: "James Okafor, RP",
    role: "Lead Addictions Counsellor",
    bio: "A registered psychotherapist specializing in CBT, DBT and trauma-informed care for addiction and co-occurring disorders.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=compress&w=800&q=80",
  },
  {
    name: "Elena Rossi, MSW",
    role: "Family Care Coordinator",
    bio: "Elena guides families through education and healing, helping loved ones rebuild trust and communication.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=compress&w=800&q=80",
  },
  {
    name: "David Chen",
    role: "Aftercare & Alumni Lead",
    bio: "A person in long-term recovery himself, David keeps our alumni community connected and supported for life.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=compress&w=800&q=80",
  },
  {
    name: "Priya Sharma, RD",
    role: "Nutritionist",
    bio: "Priya designs nourishing meals that support physical recovery and restore energy, health and well-being.",
    image: "https://images.unsplash.com/photo-1614289371518-722f2615943d?auto=compress&w=800&q=80",
  },
];

export const NAV_LINKS = [
  {
    id: "admission",
    label: "Admission",
    children: [
      { id: "preparing", label: "Preparing for Your Stay", to: "/admission/preparing-for-your-stay" },
      { id: "during", label: "During Your Stay", to: "/admission/during-your-stay" },
      { id: "financing", label: "Financing Your Stay", to: "/admission/financing-your-stay" },
    ],
  },
  {
    id: "insurance",
    label: "Insurance Coverage",
    children: [
      { id: "greenshield", label: "GreenShield Coverage", to: "/greenshield" },
      { id: "other-insurance", label: "Other Insurance Coverage", to: "/other-insurance" },
      { id: "verify-benefits", label: "Verify My Benefits", to: "/verify-benefits" },
    ],
  },
  {
    id: "about",
    label: "About Us",
    children: [
      { id: "what-we-treat", label: "What We Treat", to: "/about/what-we-treat" },
      { id: "get-involved", label: "Get Involved", to: "/about/get-involved" },
    ],
  },
  {
    id: "programs",
    label: "Programs",
    children: [
      { id: "inpatient", label: "Inpatient Treatment", to: "/programs/inpatient-treatment" },
      { id: "aftercare", label: "Aftercare", to: "/programs/aftercare" },
      { id: "family", label: "Family Care", to: "/programs/family-care" },
    ],
  },
  { id: "faqs", label: "FAQs", to: "/faqs" },
  { id: "gallery", label: "Gallery", to: "/gallery" },
  { id: "resources", label: "Resources", to: "/resources" },
  { id: "stories", label: "Real Stories", to: "/stories" },
  { id: "contact", label: "Contact Us", to: "/contact" },
];

export const CONTACT = {
  phone: "1-647-482-6308",
  phoneHref: "tel:+16474826308",
  email: "info@newbeginningsrecovery.ca",
  location: "Near the Scarborough Bluffs, Toronto, ON",
  address_line1: "69 Gradwell Drive",
  address_line2: "Scarborough, Ontario M1M 2N1",
  address_note: "Cliffcrest, near the Scarborough Bluffs",
};

export const PROGRAMS = [
  {
    id: "inpatient",
    icon: Home,
    name: "Inpatient Treatment",
    tagline: "Residential 28-day program",
    desc: "Our residential drug and alcohol rehab facility offers daily programming, round-the-clock supervision and on-call medical care — plus integrated treatment for co-occurring mental health disorders.",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_fresh-start-journey/artifacts/shz6r4hg_7ac919d0ac4166a09b2ed6639afab9851d8cbc91dee9e85fe3077fe53ec6aef4.png",
  },
  {
    id: "aftercare",
    icon: Compass,
    name: "Aftercare Options",
    tagline: "Support for life",
    desc: "Recovery doesn't end at 28 days. We emphasize aftercare to help you maintain lasting sobriety — with ongoing support, an alumni community and the same trusted team, for a lifetime.",
    image: "https://images.pexels.com/photos/19473771/pexels-photo-19473771.jpeg?auto=compress&w=1200&q=80",
  },
  {
    id: "family",
    icon: HeartHandshake,
    name: "Family Care",
    tagline: "Healing together",
    desc: "New Beginnings Recovery's Introduction to Family Care Program educates and supports loved ones — because addiction affects the whole family, and so does recovery.",
    image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=compress&w=1200&q=80",
  },
];

export const WHY_US = [
  {
    icon: Sprout,
    title: "Comprehensive Care",
    desc: "A holistic approach addressing the physical, mental, emotional and spiritual aspects of addiction.",
  },
  {
    icon: Users,
    title: "Experienced Professionals",
    desc: "A licensed, accredited, multidisciplinary team of counsellors, doctors and therapists.",
  },
  {
    icon: ShieldCheck,
    title: "Safe & Supportive",
    desc: "A secure, nurturing home where small, intimate groups allow deeply personalized attention.",
  },
  {
    icon: Brain,
    title: "Personalized Treatment",
    desc: "Individualized plans tailored to your life, work commitments, loved ones and unique goals.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Real life, from day one",
    body: "Unlike other centres, we bring real-world practice into recovery immediately. You apply your skills grocery shopping, banking and attending meetings, so each step is grounded in real life.",
  },
  {
    n: "02",
    title: "An intimate, focused setting",
    body: "Our smaller group setting allows for highly personalized care, ensuring each client receives the focused attention and support they deserve.",
  },
  {
    n: "03",
    title: "A team that stays",
    body: "We're not just here for 28 days. With ongoing aftercare, family involvement and the same trusted team, you stay supported every step of the way.",
  },
];

export const THERAPIES = [
  "Cognitive Behavioural Therapy",
  "Dialectical Behavior Therapy",
  "Addictions Counselling",
  "Meditation Therapy",
  "Life Skills Coaching",
  "SMART Recovery",
  "Anger Management",
  "Relapse Prevention",
  "Solution-Focused Therapy",
  "Mindfulness Therapy",
];

export const GALLERY = [
  { src: "/images/gallery/1exterior.jpg", label: "Exterior" },
  { src: "/images/gallery/2Welcome.jpg", label: "Welcome" },
  { src: "/images/gallery/5livingroom.jpg", label: "Living Room" },
  { src: "/images/gallery/3Diningroom.jpg", label: "Dining Room" },
  { src: "/images/gallery/4Kitchen.jpg", label: "Kitchen" },
  { src: "/images/gallery/7MasterBR.jpg", label: "Master Bedroom" },
  { src: "/images/gallery/6Bedroom.jpg", label: "Bedroom" },
  { src: "/images/gallery/9Bedroom.jpg", label: "Bedroom" },
  { src: "/images/gallery/11Bedroom.jpg", label: "Bedroom" },
  { src: "/images/gallery/12BasementArea.jpg", label: "Basement Area" },
  { src: "/images/gallery/8Neighbourhood.jpg", label: "Neighbourhood" },
];

export const TESTIMONIALS = [
  {
    quote: "Recovery has taught me that the darkest nights can lead to the brightest days. I am proof that hope and healing are real.",
    name: "Shaun S.",
    detail: "Member of the Recovery Community",
  },
  {
    quote: "New Beginnings gave me back to my family. The team never gave up on me, even when I had given up on myself.",
    name: "Former Client",
    detail: "Inpatient Program Graduate",
  },
  {
    quote: "The intimate setting made all the difference. I wasn't a number here — I was a person they truly cared about.",
    name: "Family Member",
    detail: "Family Care Program",
  },
];

export const FAQS = [
  {
    q: "How quickly can I be admitted?",
    a: "We offer immediate admittance and shorter wait lists. In many cases admission can happen the same day you call — reach out and we'll guide you through every step.",
  },
  {
    q: "How long is the inpatient program?",
    a: "Our core inpatient treatment program spans four weeks (28 days) and is tailored to prepare you for a successful, confident return to everyday life.",
  },
  {
    q: "Do you treat mental health alongside addiction?",
    a: "Yes. We provide integrated treatment for co-occurring mental health disorders such as PTSD, depression and anxiety, alongside drug and alcohol addiction.",
  },
  {
    q: "What therapies do you use?",
    a: "Our evidence-based programming includes CBT, DBT, SMART Recovery, mindfulness and meditation therapy, life skills coaching, relapse prevention and the 12 steps of recovery.",
  },
  {
    q: "Where are you located?",
    a: "Our residential treatment home is located near the scenic Scarborough Bluffs in Toronto — a calm, natural setting designed to feel like home.",
  },
  {
    q: "Can my family be involved?",
    a: "Absolutely. Our Family Care Program is built to educate and support your loved ones throughout your recovery, because healing works best together.",
  },
];

export const ICONS = { Waves };
